var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('embed', {
    attrs: {
      "id": "swfHolder",
      "src": _vm.mediaPath + '?module=' + _vm.$store.state.contentViewer.currentPlayingcontent.passcode,
      "width": "100%",
      "height": "100%",
      "flashvars": "ver=alcera_1",
      "type": "application/x-shockwave-flash"
    }
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a48230a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/contentViewer/contentHelper/swfPlayer.vue
// module id = Fu3j
// module chunks = 1